<template>
   <div class="page-loader" v-bind:class="{ show }">
      <i class="loader" v-if="show && !quoteLoader"></i>

      <div v-else class="carousel-container">
         <slot></slot>
      </div>
   </div>
</template>

<script>
export default {
   name: 'PageLoader',
   props: {
      show: Boolean,
      quoteLoader: Boolean
   }
};
</script>

<style lang="scss" src="./page-loader.scss"></style>
